import { calculateAge } from "@/pages/FormF1/helpers";

export { calculateAge };

export const PARQ_QUESTIONS = [
  "¿Te ha dicho alguna vez un médico que tienes una enfermedad cardíaca y que solo deberías hacer actividad física recomendada por él/ella?",
  "¿Sientes dolor en el pecho cuando haces actividad física?",
  "¿En el último mes, has tenido dolor en el pecho aunque no hayas hecho actividad física?",
  "¿Pierdes el equilibrio debido a mareos o has perdido el conocimiento en alguna ocasión?",
  "¿Tienes algún problema óseo o articular que pudiera empeorar con la actividad física?",
  "¿Tu médico te está prescribiendo actualmente medicamentos para la presión arterial o el corazón?",
  "¿Conoces alguna otra razón por la cual no deberías realizar actividad física?",
];

export const FLEX_OPTIONS = [
  { value: "limitada", label: "No alcanzo los pies", category: "Flexibilidad limitada", color: "#C0453A" },
  { value: "normal", label: "Toco los pies", category: "Flexibilidad normal", color: "#157346" },
  { value: "superior", label: "Sobrepaso los pies", category: "Flexibilidad superior", color: "#00628F" },
];

export const WALK_TABLE = {
  Masculino: {
    "18-29": [450, 550, 650],
    "30-39": [430, 530, 630],
    "40-49": [410, 510, 610],
    "50-59": [380, 480, 580],
    "60-69": [350, 450, 550],
    "70+": [300, 400, 500],
  },
  Femenino: {
    "18-29": [420, 520, 620],
    "30-39": [400, 500, 600],
    "40-49": [380, 480, 580],
    "50-59": [350, 450, 550],
    "60-69": [320, 420, 520],
    "70+": [270, 370, 470],
  },
};

export const SQUAT_TABLE = {
  Masculino: {
    "18-29": [15, 20, 25],
    "30-39": [13, 18, 23],
    "40-49": [11, 16, 21],
    "50-59": [10, 15, 20],
    "60-69": [8, 13, 18],
    "70+": [6, 11, 16],
  },
  Femenino: {
    "18-29": [12, 17, 22],
    "30-39": [11, 16, 21],
    "40-49": [10, 15, 20],
    "50-59": [8, 13, 18],
    "60-69": [7, 12, 17],
    "70+": [5, 10, 15],
  },
};

export const PUSHUP_TABLE = {
  Masculino: {
    "18-29": [15, 25, 35],
    "30-39": [12, 22, 30],
    "40-49": [10, 18, 25],
    "50-59": [8, 15, 21],
    "60-69": [5, 12, 18],
    "70+": [3, 9, 15],
  },
  Femenino: {
    "18-29": [10, 20, 30],
    "30-39": [8, 17, 25],
    "40-49": [6, 14, 21],
    "50-59": [4, 11, 18],
    "60-69": [2, 8, 15],
    "70+": [1, 6, 12],
  },
};

function getAgeGroup(age) {
  if (!age || age < 18) return "18-29";
  if (age <= 29) return "18-29";
  if (age <= 39) return "30-39";
  if (age <= 49) return "40-49";
  if (age <= 59) return "50-59";
  if (age <= 69) return "60-69";
  return "70+";
}

export function classifyByAgeAndSex(value, sex, age, table, labels) {
  if (value === null || value === undefined || value === "" || isNaN(parseFloat(value))) return null;
  const v = parseFloat(value);
  const effectiveAge = age || 30;
  const ageGroup = getAgeGroup(effectiveAge);
  const sexKey = sex === "Femenino" ? "Femenino" : "Masculino";
  const isDefault = sex !== "Masculino" && sex !== "Femenino";
  const thresholds = table[sexKey]?.[ageGroup];
  if (!thresholds) return null;

  let category, color, label;
  if (v < thresholds[0]) {
    category = "low"; color = "#C0453A"; label = labels[0];
  } else if (v < thresholds[1]) {
    category = "average"; color = "#F9A01B"; label = labels[1];
  } else if (v < thresholds[2]) {
    category = "good"; color = "#157346"; label = labels[2];
  } else {
    category = "excellent"; color = "#00628F"; label = labels[3];
  }
  return { category, color, label, isDefault };
}

export function getFlexCategory(value) {
  const opt = FLEX_OPTIONS.find((o) => o.value === value);
  return opt || null;
}
